import { useState } from 'react';

export const useDetectChanges = () => {
  const [_, setValue] = useState(0);
  return () => setValue((value) => value + 1);
};
